(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const wordmark = document.querySelector('.milk-footer__wordmark');
    if (!wordmark || !('IntersectionObserver' in window)) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // Only hide it once we know we can bring it back.
    wordmark.dataset.reveal = 'pending';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          wordmark.dataset.reveal = 'in';
          observer.disconnect();
        });
      },
      { threshold: 0 }
    );

    observer.observe(wordmark);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const disclosures = [...document.querySelectorAll('.milk-header [data-disclosure]')];
    const timers = new WeakMap();
    const closeDuration = () => {
      const value = getComputedStyle(document.documentElement).getPropertyValue('--dropdown-close-dur').trim();
      return parseFloat(value) * (value.endsWith('ms') ? 1 : 1000) || 150;
    };
    const close = (details, returnFocus = false) => {
      if (!details.open) return;
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector(':scope > .t-dropdown');
      clearTimeout(timers.get(details));
      summary.setAttribute('aria-expanded', 'false');
      if (!panel) {
        details.open = false;
        return;
      }
      panel.inert = true;
      panel.classList.remove('is-open');
      panel.classList.add('is-closing');
      if (returnFocus) summary.focus();
      const finish = () => {
        details.open = false;
        panel.classList.remove('is-closing');
        panel.inert = false;
      };
      if (reducedMotion.matches) finish();
      else timers.set(details, setTimeout(finish, closeDuration()));
    };
    disclosures.forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector(':scope > .t-dropdown');
      if (!summary || !panel) return;
      summary.setAttribute('aria-expanded', 'false');
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        if (details.open && !panel.classList.contains('is-closing')) {
          close(details);
          return;
        }
        disclosures.filter((other) => other !== details).forEach((other) => close(other));
        clearTimeout(timers.get(details));
        details.open = true;
        panel.inert = false;
        panel.classList.remove('is-closing');
        summary.setAttribute('aria-expanded', 'true');
        void panel.offsetHeight;
        panel.classList.add('is-open');
      });
      panel.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (
          !link ||
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }
        close(details);
      });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close(details, true);
        }
      });
      details.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!details.contains(document.activeElement)) close(details);
        });
      });
    });
    document.addEventListener('click', (event) => {
      disclosures.forEach((details) => {
        if (!details.contains(event.target)) close(details);
      });
    });
    matchMedia('(min-width: 990px)').addEventListener('change', () => {
      disclosures.forEach((details) => close(details));
    });
    document.documentElement.classList.add('motion-ready');

    /**
     * The bar ships pinned (opaque) so it stays legible with no JS. We only
     * unpin it while a section has declared that it runs full-bleed underneath
     * the header and is still covering the whole bar.
     */
    const header = document.querySelector('.milk-header');
    if (!header) return;

    let overlapEl = null;
    let overlapPx = 0;
    let scrimDepth = 0;
    let frame = 0;

    const sync = () => {
      frame = 0;
      const covered = overlapPx > 0 && overlapEl.getBoundingClientRect().bottom > scrimDepth;
      header.dataset.pinned = covered ? 'false' : 'true';
    };

    const chrome = document.querySelector('meta[name="theme-color"]');

    const paintChrome = () => {
      if (!chrome) return;
      const declared = getComputedStyle(header).getPropertyValue('--header-theme-color').trim();
      if (declared) chrome.content = declared;
    };

    const measure = () => {
      paintChrome();
      overlapEl = document.querySelector('[data-header-overlap]');
      const runout = parseFloat(getComputedStyle(header).getPropertyValue('--scrim-runout')) || 0;
      scrimDepth = header.offsetHeight + runout;
      overlapPx = overlapEl
        ? parseFloat(getComputedStyle(overlapEl).getPropertyValue('--header-overlap')) || 0
        : 0;
      sync();
    };

    const queue = () => {
      if (!frame) frame = requestAnimationFrame(sync);
    };

    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', measure);
    document.addEventListener('shopify:section:load', measure);
    measure();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milk-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

    const bind = (root) => {
      if (!root || root.dataset.galleryBound === 'true') return;
      const dialog = root.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      root.dataset.galleryBound = 'true';

      const frame = dialog.querySelector('.milk-gallery__frame');
      const photo = dialog.querySelector('img');
      const caption = dialog.querySelector('.milk-gallery__bar p');
      const closeButton = dialog.querySelector('.milk-gallery__close');
      let opener;
      let closeTimer;

      const closeMs = () => {
        const value = getComputedStyle(root).getPropertyValue('--gallery-close-dur').trim();
        const parsed = parseFloat(value);
        if (Number.isNaN(parsed)) return 150;
        if (value.endsWith('ms')) return parsed;
        return parsed * 1000;
      };

      const finishClose = () => {
        dialog.close();
        frame.classList.remove('is-closing');
        document.documentElement.classList.remove('gallery-viewer-open');
        opener?.focus({ preventScroll: true });
      };

      const close = () => {
        if (!dialog.open || frame.classList.contains('is-closing')) return;
        frame.classList.remove('is-open');
        frame.classList.add('is-closing');
        if (reducedMotion.matches) {
          finishClose();
          return;
        }
        closeTimer = setTimeout(finishClose, closeMs());
      };

      const open = (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        const link = event.currentTarget;
        event.preventDefault();
        clearTimeout(closeTimer);
        opener = link;
        photo.src = link.href;
        const thumb = link.querySelector('img');
        photo.alt = thumb ? thumb.alt : '';
        caption.textContent = link.dataset.caption || '';
        frame.classList.remove('is-open', 'is-closing');
        dialog.showModal();
        document.documentElement.classList.add('gallery-viewer-open');
        void frame.offsetHeight;
        frame.classList.add('is-open');
        closeButton.focus({ preventScroll: true });
      };

      for (const link of root.querySelectorAll('[data-gallery-photo]')) {
        link.addEventListener('click', open);
      }
      closeButton.addEventListener('click', close);
      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) close();
      });
    };

    for (const root of document.querySelectorAll('.milk-gallery')) {
      bind(root);
    }
    document.addEventListener('shopify:section:load', (event) => {
      bind(event.target.querySelector('.milk-gallery'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milk-hero-book"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heading = document.querySelector('.milk-hero .t-stagger');
    if (!heading) return;
    void heading.offsetHeight;
    requestAnimationFrame(() => heading.classList.add('is-shown'));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milk-timely-embed"] && !Shopify.designMode) return;
  try {
    
  /**
   * A service link arrives as `/pages/book?service=<code>`, and the code is
   * Timely's own product id from their booking-link builder. Handing it to the
   * widget lands the visitor on that treatment with the category and service
   * steps already behind them, without sending them off the site to get there.
   *
   * The frame ships with the plain booking URL, so a visitor with no
   * JavaScript, or one who arrives with no service on the query string, still
   * gets a working booking flow. This only ever narrows it.
   */
  (() => {
    const service = new URLSearchParams(location.search).get('service');
    if (!service) return;

    const frame = document.querySelector('.milk-book__frame iframe');
    if (!frame || !frame.src) return;

    const src = new URL(frame.src);
    if (src.searchParams.get('product') === service) return;
    src.searchParams.set('product', service);
    frame.src = src.toString();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class MilkVariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variant-json]');
      if (!data) return;

      try {
        this.variants = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }

      this.root = this.closest('.milk-product');
      this.select = this.querySelector('[data-variant-select]');
      if (!this.root || !this.select) return;

      this.classList.add('is-enhanced');
      this.addEventListener('change', this.onChange);
      this.updateAvailability();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange = (event) => {
      if (!event.target.matches('.milk-product__value-input')) return;
      this.updateAvailability();
      this.apply(this.match(this.chosen()));
    };

    chosen() {
      return Array.from(this.querySelectorAll('.milk-product__value-input:checked')).map(
        (input) => input.value
      );
    }

    match(values) {
      return this.variants.find(
        (variant) =>
          variant.options.length === values.length &&
          variant.options.every((option, index) => option === values[index])
      );
    }

    /* Cross out values that cannot be combined with the current selection. */
    updateAvailability() {
      const values = this.chosen();

      this.querySelectorAll('.milk-product__option').forEach((fieldset, index) => {
        fieldset.querySelectorAll('.milk-product__value-input').forEach((input) => {
          if (input.checked) {
            input.disabled = false;
            return;
          }

          const candidate = values.slice();
          candidate[index] = input.value;

          const reachable = this.variants.some(
            (variant) =>
              variant.available &&
              variant.options[index] === input.value &&
              variant.options.every(
                (option, position) => position === index || option === candidate[position]
              )
          );

          input.disabled = !reachable;
        });
      });
    }

    apply(variant) {
      const button = this.root.querySelector('[data-add-button]');
      const price = this.root.querySelector('[data-variant-price]');
      const compare = this.root.querySelector('[data-variant-compare]');
      const image = this.root.querySelector('[data-variant-image]');

      /* Only the label is rewritten. The busy and done layers are siblings, so
         setting textContent on the button itself would delete them. */
      const label = button && button.querySelector('[data-add-label]');

      if (!variant) {
        if (button) {
          button.disabled = true;
          if (label) label.textContent = button.dataset.labelUnavailable;
        }
        return;
      }

      this.select.value = variant.id;

      if (price) price.textContent = variant.price;

      if (compare) {
        if (variant.compare_at) {
          compare.textContent = variant.compare_at;
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      if (button) {
        button.disabled = !variant.available;
        if (label) {
          label.textContent = variant.available
            ? button.dataset.labelAvailable
            : button.dataset.labelSoldOut;
        }
      }

      /* The strip owns the photograph once it is on the page, so a variant
         asks it to move rather than writing over the frame behind its back —
         otherwise the thumbnail underneath still claims to be the one showing. */
      const gallery = this.root.querySelector('milk-product-gallery');

      if (gallery && variant.image_id && typeof gallery.selectByImageId === 'function') {
        gallery.selectByImageId(variant.image_id);
      } else if (image && variant.image) {
        image.src = variant.image;
        image.removeAttribute('srcset');
        if (variant.alt) image.alt = variant.alt;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }
  }

  class MilkProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;

      this.main = this.querySelector('[data-main-image]');
      this.trigger = this.querySelector('[data-product-zoom]');
      this.thumbs = Array.from(this.querySelectorAll('[data-product-thumb]'));
      if (!this.main || !this.trigger) return;

      this.bound = true;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

      /* One photograph has no strip, so the frame itself is the only source
         for the viewer. With a strip, the frames are the record. */
      const sources = this.thumbs.length > 0 ? this.thumbs : [this.trigger];

      this.items = sources.map((source) => ({
        id: source.dataset.imageId || '',
        main: source.dataset.main || source.href,
        full: source.dataset.full || source.href,
        srcset: source.dataset.srcset || '',
        alt: source.dataset.alt || '',
      }));

      this.index = Number(this.trigger.dataset.index) || 0;

      this.thumbs.forEach((thumb, position) => {
        thumb.addEventListener('click', (event) => {
          if (this.modified(event)) return;
          event.preventDefault();
          this.select(position);
        });
      });

      this.setUpViewer();
    }

    modified(event) {
      return (
        event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
      );
    }

    /* Move the strip to one of its frames. */
    select(position) {
      const item = this.items[position];
      if (!item) return;

      this.index = position;

      if (item.srcset) {
        this.main.srcset = item.srcset;
      } else {
        this.main.removeAttribute('srcset');
      }

      this.main.src = item.main;
      this.main.alt = item.alt;

      this.trigger.href = item.full;
      this.trigger.dataset.index = String(position);

      this.thumbs.forEach((thumb, other) => {
        thumb.classList.toggle('is-active', other === position);
        if (other === position) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    selectByImageId(id) {
      if (!id) return;
      const position = this.items.findIndex((item) => item.id === String(id));
      if (position > -1) this.select(position);
    }

    setUpViewer() {
      const dialog = this.querySelector('dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;

      this.dialog = dialog;
      this.frame = dialog.querySelector('.milk-product__frame');
      this.photo = dialog.querySelector('[data-viewer-image]');
      this.counter = dialog.querySelector('[data-viewer-counter]');
      this.closeButton = dialog.querySelector('.milk-product__viewer-close');
      if (!this.frame || !this.photo || !this.closeButton) return;

      this.trigger.addEventListener('click', (event) => {
        if (this.modified(event)) return;
        event.preventDefault();
        this.open(this.index);
      });

      const prev = dialog.querySelector('[data-viewer-prev]');
      const next = dialog.querySelector('[data-viewer-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.closeButton.addEventListener('click', () => this.close());

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) this.close();
      });

      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.step(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.step(1);
        }
      });
    }

    closeMs() {
      const value = getComputedStyle(this).getPropertyValue('--viewer-close-dur').trim();
      const parsed = parseFloat(value);
      if (Number.isNaN(parsed)) return 150;
      if (value.endsWith('ms')) return parsed;
      return parsed * 1000;
    }

    /* The viewer reads from the same list the strip does, so stepping through
       it and tapping a thumbnail afterwards agree on where you are. */
    show(position) {
      const item = this.items[position];
      if (!item) return;

      this.viewerIndex = position;
      this.photo.src = item.full;
      this.photo.alt = item.alt;

      if (this.counter) {
        const format = this.dialog.dataset.counterFormat || 'INDEX / TOTAL';
        this.counter.textContent = format
          .replace('INDEX', String(position + 1))
          .replace('TOTAL', String(this.items.length));
      }
    }

    step(direction) {
      const total = this.items.length;
      if (total < 2) return;
      const position = (this.viewerIndex + direction + total) % total;
      this.show(position);
      this.select(position);
    }

    open(position) {
      clearTimeout(this.closeTimer);
      this.show(position);
      this.frame.classList.remove('is-open', 'is-closing');
      this.dialog.showModal();
      document.documentElement.classList.add('product-viewer-open');
      void this.frame.offsetHeight;
      this.frame.classList.add('is-open');
      this.closeButton.focus({ preventScroll: true });
    }

    finishClose() {
      this.dialog.close();
      this.frame.classList.remove('is-closing');
      document.documentElement.classList.remove('product-viewer-open');
      this.trigger.focus({ preventScroll: true });
    }

    close() {
      if (!this.dialog.open || this.frame.classList.contains('is-closing')) return;

      this.frame.classList.remove('is-open');
      this.frame.classList.add('is-closing');

      if (this.reducedMotion.matches) {
        this.finishClose();
        return;
      }

      this.closeTimer = setTimeout(() => this.finishClose(), this.closeMs());
    }
  }

  if (!customElements.get('milk-product-gallery')) {
    customElements.define('milk-product-gallery', MilkProductGallery);
  }

  if (!customElements.get('milk-variant-picker')) {
    customElements.define('milk-variant-picker', MilkVariantPicker);
  }

  } catch(e) { console.error(e); }
})();
})();
